/*!
* @bowencool/async-utilities v2.5.4
*/
function throttleAsyncResult(fn, _temp) {
  let {
    useSamePromise = false
  } = _temp === void 0 ? {} : _temp;
  let isPending = false;
  let theLastPromise = null;
  return function asyncThrottled() {
    if (isPending) {
      if (useSamePromise && theLastPromise) {
        return theLastPromise;
      }

      return new Promise(() => {});
    } else {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      const ret = fn.call(this, ...args).then(function () {
        isPending = false;
        theLastPromise = null;
        return Promise.resolve(...arguments);
      }).catch(function () {
        isPending = false;
        theLastPromise = null;
        return Promise.reject(...arguments);
      });
      theLastPromise = ret;
      isPending = true;
      return ret;
    }
  };
}

export { throttleAsyncResult };
